<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import medicionFrecuenciaAPI from "@/services/standards/medicionFrecuencia/medicionFrecuenciaAPI";
import ItemAPI from "@/services/items/itemsAPI";
import CheckModal from "@/components/CheckModal";
import medicionPrevalenciaAPI from "../../../services/standards/medicionPrevalencia/medicionPrevalenciaAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.3.4 Medición de la prevalencia de la enfermedad laboral",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    CheckModal,
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "3.3.4 Medición de la prevalencia de la enfermedad laboral",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Medición",
        },

        {
          text: "Ver",
          active: true,
        },
      ],

      itemData: null,
      item: null,
      years: [],
      lista: [],
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      medicion: {
        annual_goal: null,
        annual_period: 1,
        year: null,
        people_know_result: null,
        responsible_measurement: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(38)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 38)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      medicionPrevalenciaAPI
        .show(this.$route.params.id)
        .then((response) => {
          this.medicion = {
            annual_goal: response.data.annual_goal,
            annual_period: response.data.annual_period,
            year: response.data.year,
            people_know_result: response.data.people_know_result,
            responsible_measurement: response.data.responsible_measurement,
            companies_id: response.data.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      medicionFrecuenciaAPI
        .getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    rangeYear() {
      const max = 2040;
      const min = 2019;
      for (let i = min; i <= max; i++) {
        this.years.push(i);
      }
      return this.years;
    },

    goPage(page) {
      window.location.href = page;
    },
  },

  mounted() {
    this.rangeYear();
    this.getList();
    this.getItems();
    this.getItemData();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12 m-0 p-0">
        <div class="card">
          <div class="card-body">
            <div class="row px-4">
              <div class="col-12 text-right m-b-0">
                <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="back" placement="left"> Volver </b-tooltip>
              </div>
            </div>

            <hr />

            <form class="form-group" @submit.prevent="save">
              <div class="table-responsive px-4 mt-2" v-if="getRole('Consultar')">
                <table class="table-sm pt-2 table border-bottom divide-y divide-gray-200 table-bordered rounded">
                  <thead class="bg-primary text-light">
                    <tr>
                      <th class="text-center align-middle" colspan="4">
                        Ficha tecnica del indicador
                      </th>
                    </tr>
                    <tr>
                      <th class="text-center align-middle">Nombre indicador</th>
                      <th class="text-center align-middle" colspan="3">
                        Prevalencia de la enfermedad laboral P.EL
                      </th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Formula</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        ((Número de casos nuevos + antiguos de enfermedad
                        laboral en el período)/Promedio de trabajadores en el
                        año) * 100.000
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Intrerpretación del indicador</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        Por cada 100.000 trabajadores existen X casos de
                        enfermedad laboral en el año Y.
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Meta</b>
                      </td>
                      <td class="text-center align-middle">
                        <b-form-input class="col-md-4" type="number" disabled id="date_exam"
                          v-model="medicion.annual_goal">
                        </b-form-input>
                      </td>
                      <td class="text-center align-middle" colspan="2">
                        <select required disabled class="col-md-8 form-control" v-model="medicion.year">
                          <b-form-select-option v-for="item in years" :value="item">
                            {{ item }}
                          </b-form-select-option>
                        </select>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Periocidad</b>
                      </td>

                      <td class="text-center align-middle" colspan="3">
                        Anual
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b>Fuente de la información</b>
                      </td>
                      <td class="align-middle" colspan="3">
                        <p>Casos nuevos y antiguos de enfermedad laboral</p>
                        <p>Número de trabajadores en el mes</p>
                        <p>
                          La constante 100.000 para indicadores de enfermedad
                          laboral es utilizada por la Organización Mundial de la
                          Salud para la estadística internacional, permitiendo
                          compartación estandarizada
                        </p>
                        <p>Número de accidesntes de trabajo en el mes</p>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Personas que deben conocer el resultado</b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input disabled type="text" id="date_exam" maxlength="200"
                          v-model="medicion.people_know_result">
                        </b-form-input>
                      </td>
                    </tr>
                    <tr>
                      <td class="bg-primary text-light text-center align-middle">
                        <b> Responsable de la medición </b>
                      </td>
                      <td class="text-center align-middle" colspan="3">
                        <b-form-input disabled type="text" id="date_exam" maxlength="200"
                          v-model="medicion.responsible_measurement">
                        </b-form-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
